module.exports = __webpack_public_path__ + "img/20190912105032718.5078eb93.jpg";